<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-p-3 ts-flex ts-space-x-3">
    <div>
      <label>{{ $t('saleContract.promotionName') }}</label>
      <input v-model="model.promotion_name" type="text" class="form-control" />
      <div class="validate" v-if="errors.has('promotion_name')">
        {{ errors.first('promotion_name') }}
      </div>
    </div>
    <div>
      <label>{{ $t('saleContract.promotionAmount') }}</label>
      <input
        v-model.number="model.promotion_amount"
        type="number"
        class="form-control"
      />
      <div class="validate" v-if="errors.has('promotion_amount')">
        {{ errors.first('promotion_amount') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'promotion',
  props: ['value', 'validate'],
  data () {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['formViewData']),
    khrRate () {
      if (this.formViewData.exchangeRate) {
        let foundFx =
          this.$store.state.wholesale.saleContract.formViewData.exchangeRate.find(
            e => e.to_currency == 'KHR'
          )
        if (foundFx) {
          return (this.model.fx_rate_khr = parseFloat(foundFx.fx_rate))
        }
      }
      return 0
    },
    thbRate () {
      if (this.formViewData.exchangeRate) {
        let foundFx =
          this.$store.state.wholesale.saleContract.formViewData.exchangeRate.find(
            e => e.to_currency == 'THB'
          )
        if (foundFx) {
          return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
        }
      }
      return (this.model.fx_rate_thb = 32)
    }
  }
}
</script>
